import { useTranslation } from "react-i18next";
import Modal from "../../boxes/Modal";

const CareBalanceStatusModal = ({ onClose }) => {
  const { t } = useTranslation("careBalance");

  return (
    <Modal
      title={t("inactiveBalanceModalTitle")}
      onClose={onClose}
      style={{
        fontWeight: 700,
        color: "#212121",
        fontSize: "2.4rem",
        alignSelf: "flex-start",
      }}
      modalContentStyle={{
        minHeight: "unset",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          rowGap: "16px",
          maxWidth: "600px",
        }}
      >
        <p
          style={{
            fontSize: "1.688rem",
            lineHeight: "100%",
            letterSpacing: "0%",
            color: "#000000",
          }}
        >
          {t("inactiveBalanceModalDescription")}
        </p>

        <button
          onClick={onClose}
          style={{
            width: "100%",
            backgroundColor: "#094063",
            color: "#ffffff",
            padding: "11.5px 12px",
            fontSize: "1.744rem",
            lineHeight: "100%",
            letterSpacing: "0%",
            fontWeight: 700,
            borderRadius: "4px",
          }}
        >
          {t("inactiveBalanceModalButton")}
        </button>
      </div>
    </Modal>
  );
};

export default CareBalanceStatusModal;
